import { PaymentMethodType } from "@/types/enums/payment";

/**
 * Map a rainforest-payment "method-updated" event to the method the form is on.
 * The event passes the active method as a plain string in detail[0] (e.g.
 * "CARD", "ACH", "APPLE_PAY"); anything other than card or bank maps to null.
 */
export function methodTypeFromRainforestEvent(
  event: unknown,
): PaymentMethodType | null {
  const raw = (event as { detail?: unknown[] } | undefined)?.detail?.[0];
  if (raw === "ACH") return PaymentMethodType.ACH;
  if (raw === "CARD") return PaymentMethodType.CARD;
  return null;
}
